import { NXChart, NXRefresh } from "../../icons";
import SummaryChart from "./SummaryChart";

function TotalOrderOverview({ className }: { className?: string; }) {
  

  
  return (
    <div className={`${className} bg-white rounded-lg p-5`}>
      <div className="flex flex-col md:flex-row gap-3 justify-start md:justify-between items-center border-b border-[#EEEFF2] pb-3">
        <div className="flex items-center gap-3">
          <NXChart />
          <h2 className="font-nunito font-nunito-h1 text-xl">
            Order Overview
          </h2>
        </div>
        <p className="flex items-center gap-1">
          <span className="text-base-300">Last update:</span>
            <strong>{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</strong>
          <NXRefresh />
        </p>
      </div>
      {/* chart section */}
      <div className="flex flex-col lg:flex-row gap-5 justify-between">
        <SummaryChart />
      </div>
    </div>
  );
}

export default TotalOrderOverview;
